import * as Yup from 'yup';
import moment from 'moment';

export const getOnboardOrganizationSchema = (step: number) => {
  if (step === 1) {
    return Yup.object().shape({
      fullName: Yup.string().required('Full Name is required'),
      email: Yup.string()
        .email('Invalid email format')
        .matches(/^[a-zA-Z0-9](.*[a-zA-Z0-9])?$/, 'Invalid email format')
        .required('Email is required'),
      contact: Yup.string().matches(
        /^\+?[0-9\s\-()]{7,20}$/,
        'Contact must be a valid phone number',
      ),
      dob: Yup.date().max(
        moment().toDate(),
        'Date of Birth cannot be in the future',
      ),
    });
  } else if (step === 2) {
    return Yup.object().shape({
      licenseCount: Yup.number()
        .typeError('License Count must be a number')
        .required('License Count is required')
        .positive('License Count must be a positive number')
        .integer('License Count must be a whole number'),
      isPaid: Yup.boolean()
        .required('Payment status is required')
        .typeError('Payment status must be selected'),
        amount: Yup.number()
        .nullable()
        .positive('Amount must be a positive number')
        .notRequired(),
      companyName: Yup.string().required('Company Name is required'),
      industryType: Yup.string().required('Industry Type is required'),
      industrySize: Yup.string().required('Industry Size is required'),
      headquarterAddress: Yup.string().required(
        'Headquarter Address is required',
      ),
      organizationContact: Yup.string().matches(
        /^\+?[0-9\s\-()]{7,20}$/,
        'Contact must be a valid phone number',
      ),
    });
  } else {
    return Yup.object();
  }
};
